(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ConstantContact.CCCampaignList",
                    {
                        url: "/CampaignList",
                        component: "ccCampaignList",
                        PageTitle: "Constant Contact Campaign List | Marketing Tracker",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app.component("ccCampaignList",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ConstantContact/CCCampaignList/cc-campaign-list-template.html",
            controller: ccCampaignListController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    ccCampaignListController.$inject = ["figToaster", "marketingTrackerConstantContactApi", "$window", "$state"];
    function ccCampaignListController(figToaster, marketingTrackerConstantContactApi, $window, $state) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loadingData: false,
                    hasCCToken: false
                },
                connectToConstantContact: connectToConstantContact,
                pageSizes: [25, 50, 100],
                refreshData: refreshData,
                toggleSort: toggleSort
            });

        function _resetFilters(propertyName, pageSize, reverseOrder, currentPage, ccCampaignSearch) {
            $ctrl.propertyName = propertyName || 'Name';
            $ctrl.pageSize = pageSize || $ctrl.pageSizes[0];
            $ctrl.reverseOrder = reverseOrder || false;
            $ctrl.currentPage = currentPage || 1;
            $ctrl.ccCampaignSearch = ccCampaignSearch || '';
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _setSelectedCampaign(campaign) {
            $ctrl.selectedCampaign = campaign;
            return campaign;
        }

        function refreshData() {
            _resetFilters();
        }
        
        function connectToConstantContact() {
            /*marketingTrackerConstantContactApi.postConnect().then(function (response) {
                console.log('Get Authentication URl from Marketing Tracker' + response);
                $window.open(response.Url, '_blank');
            });*/

            $state.go('Home.Tools.MarketingTrackerNew.Settings.Integrations');
        }

        $ctrl.$onInit = function () {
            $ctrl.ui.loadingData = true;
            _resetFilters();
            message = "";
            toastClass = "";
            marketingTrackerConstantContactApi.getHasToken()
                .then(function (hasToken) {
                    if (hasToken) {
                        $ctrl.ui.hasCCToken = true;
                        marketingTrackerConstantContactApi.getCampaigns()
                            .then(function (response) {
                                $ctrl.constantContactCampaigns = _.filter(response, function (campaign) {
                                    return campaign.status !== 'DRAFT';
                                });
                            })
                            .catch(function (error) {
                                console.log("Error: " + error.data);
                                message = "There was a problem retrieving your data. Please try again shortly.";
                                toastClass = "is-error";
                                figToaster.showSimple(message, "top", toastClass);
                            });
                    }
                })
                .finally(function () {
                    $ctrl.ui.loadingData = false;
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line